<template>
  <b-modal
    id="modal-alterar-senha"
    ref="modal-alterar-senha"
    :title="titulo"
    @show="resetModal"
    @hidden="resetModal"
    @ok="handleOk"
    :no-close-on-esc="trocar_senha"
    :no-close-on-backdrop="trocar_senha"
    :hide-header-close="trocar_senha"
  >
    <g-loading :loading="isLoading">
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          :label="$t('Senha Atual')"
          label-for="senha-atual-input"
          :invalid-feedback="$t('Senha Atual é requerida')"
          :state="validateState('senha-atual-input')"
        >
          <b-form-input
            type="password"
            id="senha-atual-input"
            name="senha-atual-input"
            v-model="senhaAtual"
            :state="validateState('senha-atual-input')"
            v-validate="'required'"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label-for="nova-senha-input"
          :invalid-feedback="$t('Nova Senha é requerida')"
          :state="validateState('nova-senha-input')"
        >
          <label>
            <span>
              {{ $t('Nova Senha') }}
              <b-icon-info-circle class="cursor-pointer" v-b-popover.hover.top="$t($msg.passwordRules)" />
            </span>

            <span @click="makePassword" class="cursor-pointer">
              <b-icon-file-lock2
                :tooltip="$t('Gerar senha')"
                v-b-tooltip.hover
                font-scale="1.5"
                class="ml-3 cursor-pointer"
              />
            </span>
          </label>

          <b-input-group>
            <b-input
              :type="show_password ? 'text' : 'password'"
              id="nova-senha-input"
              name="nova-senha-input"
              ref="nova-senha-input"
              v-model="novaSenha"
              :state="validateState('nova-senha-input')"
              v-validate="'required'"
              required
            />
            <b-input-group-prepend is-text @click="show_password = !show_password">
              <b-icon-eye v-if="!show_password" />
              <b-icon-eye-slash v-else />
            </b-input-group-prepend>
          </b-input-group>
        </b-form-group>
        <b-form-group
          :label="$t('Confirmar Nova Senha')"
          label-for="confirmar-nova-senha-input"
          :invalid-feedback="$t('As senhas não são iguais. Tente novamente.')"
          :state="validateState('confirmar-nova-senha-input')"
        >
          <b-input-group>
            <b-input
              :type="show_password ? 'text' : 'password'"
              id="confirmar-nova-senha-input"
              name="confirmar-nova-senha-input"
              v-model="confirmarNovaSenha"
              :state="validateState('confirmar-nova-senha-input')"
              v-validate="'required|confirmed:nova-senha-input'"
              required
            />
            <b-input-group-prepend is-text @click="show_password = !show_password">
              <b-icon-eye v-if="!show_password" />
              <b-icon-eye-slash v-else />
            </b-input-group-prepend>
          </b-input-group>
        </b-form-group>
      </form>
    </g-loading>
    <template slot="modal-footer">
      <b-button @click="hide()" :disabled="isLoading">
        {{ !this.trocar_senha ? $t('Fechar') : $t('Sair do Sistema') }}
      </b-button>
      <b-button variant="primary" @click="handleSubmit()" :disabled="isLoading">
        {{ $t('Confirmar') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      titulo: this.$i18n.t('Alterar Senha'),
      senhaAtual: null,
      novaSenha: null,
      confirmarNovaSenha: null,
      isLoading: false,
      name: '',
      senhaAtualState: null,
      novaSenhaState: null,
      submittedNames: [],
      trocar_senha: false,
      show_password: false
    };
  },
  mounted() {
    this.trocar_senha = this.$store.state.user.info.trocar_senha;
  },
  methods: {
    hide() {
      if (!this.trocar_senha) {
        this.$bvModal.hide('modal-alterar-senha');
      } else {
        this.logOut();
      }
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    resetModal() {
      this.titulo = this.$i18n.t('Alterar Senha');
      this.senhaAtual = null;
      this.novaSenha = null;
      this.confirmarNovaSenha = null;
      this.isLoading = false;
    },
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    validatePassword() {
      if (this.novaSenha) {
        if (!this.$util.isStrengthPassword(this.novaSenha)) {
          return false;
        }
        if (this.novaSenha != this.confirmarNovaSenha) {
          this.$util.formWarn({
            msgTitle: 'Atenção',
            msgContent: 'As senhas não são iguais. Tente novamente.'
          });
          return false;
        }
      }

      return true;
    },
    makePassword() {
      this.show_password = false;
      this.novaSenha = this.$util.makeRandomString(8);
      this.confirmarNovaSenha = this.novaSenha;
      this.show_password = true;
    },
    handleSubmit() {
      if (!this.validatePassword()) return;

      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.$notify({
            group: 'notifications-default',
            type: 'warn',
            title: this.$i18n.t('Erro ao Salvar'),
            text: this.$i18n.t('Verifique os campos obrigatórios.'),
            duration: 4000
          });
          return;
        }
        this.isLoading = true;
        this.$atenaList
          .alterarSenha({
            senha_atual: this.senhaAtual,
            nova_senha: this.novaSenha
          })
          .then((res) => {
            this.isLoading = false;
            this.$store.state.user.info.trocar_senha = false;

            this.$notify({
              group: 'notifications-default',
              type: 'success',
              title: this.$i18n.t('Sucesso'),
              text: this.$i18n.t('Senha Alterada com Sucesso'),
              duration: 4000
            });
            this.$nextTick(() => {
              this.trocar_senha = false;
              this.$store.dispatch('gloading/hide', 'saveManager');
              this.$bvModal.hide('modal-alterar-senha');
            });
          })
          .catch((err) => {
            this.isLoading = false;
            this.$notify({
              group: 'notifications-default',
              type: 'warn',
              title: this.$i18n.t('Erro ao Alterar Senha'),
              text: `${err.code} - ${err.message}`,
              duration: 4000
            });
          });
      });
    },
    logOut() {
      this.$auth.logout();

      this.$router.push({ path: '/' }).then(() => {
        this.$util.formWarn({
          msgTitle: 'Até logo!',
          msgContent: 'Sua sessão foi encerrada com sucesso',
          type: 'success'
        });
      });
    }
  }
};
</script>
